import * as React from "react";

const ThumbsDownIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.868}
    height={19.836}
    viewBox="0 0 20 20"  // Adding the viewBox attribute
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M1.878 12.507A1.881 1.881 0 0 1 0 10.628l.008-.008a1.887 1.887 0 0 1 .91-1.6A1.87 1.87 0 0 1 1 6.3a.463.463 0 0 1 .067-.05 1.969 1.969 0 0 1 .476-.292 1.845 1.845 0 0 1-.433-1.182A1.888 1.888 0 0 1 2.2 3.073 1.689 1.689 0 0 1 3.181.368a.38.38 0 0 1 .167-.042h5.118a11.156 11.156 0 0 1 3.724 1.1v-.173A1.251 1.251 0 0 1 13.441 0h4.174a1.251 1.251 0 0 1 1.252 1.252v10.019a1.251 1.251 0 0 1-1.252 1.252h-4.174a1.251 1.251 0 0 1-1.252-1.252V11c-2.379.877-4.767 3.891-4.767 7.673a1.167 1.167 0 0 1-1.094 1.147 2.153 2.153 0 0 1-2.288-1.762c-.572-2.032.149-3.784.846-5.477l.014-.033.017-.042ZM13.441.835a.413.413 0 0 0-.417.417v10.019a.413.413 0 0 0 .417.417h4.174a.413.413 0 0 0 .417-.417V1.253a.413.413 0 0 0-.417-.417ZM2.246 9.576h-.368v.008a1.044 1.044 0 0 0 0 2.087h3.657a.41.41 0 0 1 .342.184.437.437 0 0 1 .042.392l-.25.626c-.651 1.578-1.319 3.206-.827 4.968.25.893.893 1.236 1.369 1.16.092-.017.376-.075.376-.317 0-4.3 2.847-7.689 5.6-8.549v-7.78a11.769 11.769 0 0 0-3.721-1.186H3.532a.864.864 0 0 0 0 1.728h.184a.417.417 0 0 1 0 .835h-.31a.471.471 0 0 0-.058.008h-.367a1.044 1.044 0 0 0 0 2.087.417.417 0 0 1 0 .835h-.735a1.044 1.044 0 0 0 0 2.087.417.417 0 0 1 0 .835ZM15.111 2.2a.785.785 0 1 1-.785-.785.784.784 0 0 1 .785.785Zm-.735 0c0-.025-.05-.05-.05-.05v.1Z"
    />
  </svg>
);

export default ThumbsDownIcon;
